import React, { useEffect, useState } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import { useLoader } from 'src/provider/LoaderProvider';
import { baseApi, useUpdateIntegrationMutation } from 'src/services';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { useParams } from 'react-router-dom';
import { EditIntegrationSettings } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationSettings';
import { EditIconSettings } from 'src/assets/icons/editIconsSettings';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';

export const EditIntegrationPopup = ({
  isOpen = false,
  integration,
  disabled = false,
  trigger = (
    <div className="edit-button [&_svg]:hover:opacity-100 [&_svg]:opacity-40 [&_svg]:transition [&_svg>path]:transition duration-300">
      <EditIconSettings />
    </div>
  ),
}) => {
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [open, setOpen] = useState(isOpen);
  const dispatch = useDispatch();
  const notification = useNotification();
  const { id } = useParams();
  const [
    updateIntegration,
    {
      data: updateIntegrationData,
      isSuccess: isSuccessUpdateIntegration,
      isLoading: isLoadingUpdateIntegration,
      isError: isErrorUpdateIntegration,
    },
  ] = useUpdateIntegrationMutation() as any;

  const loader = useLoader();

  const editIntegration = (data) => {
    updateIntegration({
      projectId: id,
      integrationId: data.id,
      body: data,
    }).then(() => notification.success(`Integration updated.`));
  };

  useEffect(() => {
    if (updateIntegrationData) {
      dispatch(setSelectedIntegration({ ...selectedIntegration, ...updateIntegrationData }));
    }
  }, [updateIntegrationData]);

  useEffect(() => {
    if (isSuccessUpdateIntegration) {
      notification.success(`Integration updated.`);
      loader.hide();
      onOpenChange(false);
    }
  }, [isSuccessUpdateIntegration]);

  useEffect(() => {
    if (isLoadingUpdateIntegration) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingUpdateIntegration]);

  useEffect(() => {
    if (isErrorUpdateIntegration) {
      loader.hide();
    }
  }, [isErrorUpdateIntegration]);

  useEffect(() => {
    if (!open) {
      loader.hide();
    }
  }, [open]);

  const onOpenChange = (isOpen) => {
    if (!isOpen) {
      dispatch(baseApi.util.invalidateTags(['ProjectById']));
      loader.hide();
    }

    setOpen(isOpen);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogTrigger
          disabled={disabled}
          asChild
          className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
        >
          {trigger}
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{`${selectedIntegration?.friendlyName || integration.integration_data.name} Integration Settings`}</DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <EditIntegrationSettings
              integration={integration}
              onSubmit={editIntegration}
              onCancel={() => onOpenChange(false)}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
